import React, { useState } from "react";
import { getFullImageUrl } from "../../utils/imageUrl";

const ImageWithPlaceholder = ({
  src,
  alt = "",
  className = "",
  size = "md",
  rounded = "lg",
}) => {
  const [imageError, setImageError] = useState(false);
  const imageUrl = getFullImageUrl(src);

  const sizeClasses = {
    xs: "h-7 w-7",
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
    "2xl": "h-24 w-24",
  };

  const iconSizes = {
    xs: "h-3 w-3",
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
    xl: "h-8 w-8",
    "2xl": "h-12 w-12",
  };

  const roundedClasses = {
    none: "",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  };

  const baseClasses = `${sizeClasses[size]} ${roundedClasses[rounded]} flex-shrink-0 border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 object-cover`;

  if (!imageUrl || imageError) {
    return (
      <div
        className={`${baseClasses} flex items-center justify-center ${className}`}
      >
        <svg
          className={`${iconSizes[size]} text-slate-400 dark:text-slate-500`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={`${baseClasses} ${className}`}
      onError={() => setImageError(true)}
    />
  );
};

export default ImageWithPlaceholder;
